import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";

/**
 *
 * 出差总结联系人
 */
export class ApplyTravelSummaryVontactApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-travel-summary-contact'
    }




}
